var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInfoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92888 9.92714C12.4388 9.92714 14.474 7.89107 14.474 5.3811C14.474 2.87026 12.4388 0.835938 9.92888 0.835938C7.41804 0.835938 5.38284 2.87031 5.38284 5.3811C5.37432 7.88256 7.39592 9.91863 9.89659 9.92714H9.92888Z",
    fill: "#00917D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 15.8349C0.835938 13.8261 2.46377 12.1982 4.47259 12.1982H15.3817C17.3896 12.1982 19.0175 13.8261 19.0175 15.8349V19.0164H0.835938V15.8349Z",
    fill: "#00917D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfoSvg);
export default __webpack_public_path__ + "static/media/UserInfoSVG.9fd11cc2ba045a4da05365184180e669.svg";
export { ForwardRef as ReactComponent };